class ThumbnailSlider {
  constructor(el) {
    if (!el) return

    this._bind();

    this.dom = {
      el: el,
      images: el.querySelectorAll(".js-image"),
      thumbnails: el.querySelectorAll(".js-thumbnail"),
      leftTrigger: el.querySelector(".js-left-trigger"),
      rightTrigger: el.querySelector(".js-right-trigger")
    }

    this.data = {
      cur: 0,
      last: 0,
      z: 2,
      max: this.dom.images.length - 1,
      isTransitioning: false
    }

    this._addEvents();
  }

  _bind() {
    ['next', 'prev', 'updateThumbs',]
      .forEach(fn => this[fn] = this[fn].bind(this));
  }

  _addEvents() {
    this.dom.rightTrigger.addEventListener("click", this.next, false);
    this.dom.leftTrigger.addEventListener("click", this.prev, false);
    this.dom.thumbnails.forEach((thumbnail, i) => {
      thumbnail.addEventListener("click", () => { this.clickThumb(i) }, false);
    });
  }

  next(index) {
    if (this.data.isTransitioning || this.data.max < 1) return

    this.data.isTransitioning = true;

    this.data.z += 1;

    if (Number.isInteger(index)) {
      this.data.cur = index;
    } else {
      this.data.cur += 1;
      if (this.data.cur > this.data.max) this.data.cur = 0;
    }

    this.dom.images.forEach((image, i) => {
      if (i !== this.data.last && i !== this.data.cur) gsap.set(image, { opacity: 0 });
    });


    let tl = new gsap.timeline();

    // Image Animation
    tl.fromTo(this.dom.images[this.data.cur], 1.4,
      { scale: 1.2, xPercent: 100, zIndex: this.data.z, rotate: 40, opacity: 1 },
      { scale: 1, xPercent: 0, zIndex: this.data.z, rotate: 0, transformOrigin: "0% 100%", ease: Expo.easeInOut })
    tl.to(this.dom.images[this.data.last], 1.4, { xPercent: -50, rotate: -15, transformOrigin: "0% 0%", ease: Expo.easeInOut }, "<0.1")

    tl.add(() => { this.data.isTransitioning = false }, ">-0.3");


    this.updateThumbs();
    this.data.last = this.data.cur;
  }

  prev(index) {
    if (this.data.isTransitioning || this.data.max < 1) return

    this.data.isTransitioning = true;

    this.data.z += 1;

    if (Number.isInteger(index)) {
      this.data.cur = index;
    } else {
      this.data.cur -= 1;
      if (this.data.cur < 0) this.data.cur = this.data.max;
    }

    this.dom.images.forEach((image, i) => {
      if (i !== this.data.last && i !== this.data.cur) gsap.set(image, { opacity: 0 });
    });


    let tl = new gsap.timeline();

    // Image Animation
    tl.fromTo(this.dom.images[this.data.cur], 1.4,
      { scale: 1.2, xPercent: -100, zIndex: this.data.z, rotate: -25, opacity: 1 },
      { scale: 1, xPercent: 0, zIndex: this.data.z, rotate: 0, transformOrigin: "100% 100%", ease: Expo.easeInOut })
    tl.to(this.dom.images[this.data.last], 1.4, { xPercent: 100, rotate: 15, transformOrigin: "0% 0%", ease: Expo.easeInOut }, "<0.1")

    tl.add(() => { this.data.isTransitioning = false }, ">-0.3");

    this.updateThumbs();
    this.data.last = this.data.cur;
  }

  updateThumbs() {
    this.dom.thumbnails.forEach(dot => {
      dot.classList.remove("is-selected")
    })

    this.dom.thumbnails[this.data.cur].classList.add("is-selected")
  }

  clickThumb(index) {
    if (index === this.data.cur) return

    if (index > this.data.cur) {
      this.next(index)
    } else {
      this.prev(index)
    }
  }
}